module.exports = __webpack_public_path__ + "static/media/fotcgraphic.d2fd6ef7.png";